<template>
  <div class="card-footer">
    <el-popover placement="bottom-start" v-model="forwardVisible">
      <div class="tags" slot="reference">
        <img :src="getIcon('转发')" />
        <span>{{ num(Number(info[keyDict.transmit_num])) }}</span>
      </div>
      <div class="forward">
        <div class="content">{{ forword_url }}</div>
        <div class="btn" @click="handleCopy(forword_url)">复制链接</div>
      </div>
    </el-popover>
    <div class="tags">
      <img :src="getIcon('评论')" @click="$emit('handleComment')" />
      <span>{{ num(Number(info[keyDict.comment_num])) }}</span>
    </div>
    <div class="tags">
      <img
        :src="getIcon(info[keyDict.is_like] ? '点赞_1' : '点赞')"
        @click="$emit('handleLike')"
      />
      <span :class="{ click: !!info[keyDict.is_like] }">{{
        num(Number(info[keyDict.like_num]))
      }}</span>
    </div>
    <div class="tags">
      <img
        :src="getIcon(info[keyDict.is_collect] ? '收藏_1' : '收藏')"
        @click="$emit('handleCollect')"
      />
      <span :class="{ click: !!info[keyDict.is_collect] }">{{
        num(Number(info[keyDict.collect_num]))
      }}</span>
    </div>
  </div>
</template>

<script>
import { FORWARD_URL } from "@/common/config.js";
export default {
  name: "CardFooter",
  props: {
    info: {
      type: Object,
    },
    dict: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      forwardVisible: false,
      FORWARD_URL,
      keyDict: {
        is_collect: "is_collect",
        collect_num: "collect_num",
        is_like: "is_like",
        like_num: "like_num",
        comment_num: "comment_num",
        transmit_num: "transmit_num",
      },
    };
  },
  computed: {
    forword_url() {
      let url = "";
      let routePath = this.$store.state.routePath;
      let urlDict = {
        video: {
          path: "/video-details",
          key: [
            ["id", "video_id"],
            ["videoArrId", "url_id"],
          ],
        },
        "image-text": {
          path: "/image-text-details",
          key: [
            ["id", "article_id"],
            ["item_id", "item_id"],
          ],
        },
        information: {
          path: "/information-details",
          key: [
            ["id", "datum_id"],
            ["url_id", "url_id"],
          ],
        },
      };
      for (let key in urlDict) {
        if (routePath.includes(key)) {
          url = `${FORWARD_URL}${urlDict[key].path}?`;
          let queryArr = [];
          urlDict[key].key.forEach((item) => {
            queryArr.push(`${item[0]}=${this.info[item[1]]}`);
          });
          url = url + queryArr.join("&");
        }
      }
      return url;
    },
  },
  mounted() {
    this.keyDict = { ...this.keyDict, ...this.dict };
  },
  methods: {
    getIcon(type) {
      return require(`@/assets/icon/card/${type}.png`);
    },
    // 计算数字
    num(num) {
      return !!num ? (num > 10000 ? (num / 10000).toFixed(1) + "万" : num) : 0;
    },
    //复制
    handleCopy(value) {
      let that = this;
      navigator.clipboard.writeText(value).then(function () {
        that.$message.success("复制成功");
        that.$emit("handleForward");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-footer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  user-select: none;
  .tags {
    width: 80px;
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-left: 8px;
    }
    .click {
      color: #2a63f3;
    }
  }
}
.forward {
  width: 240px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f4f4;
  border-radius: 17px;
  white-space: nowrap;
  user-select: none;
  .content {
    width: calc(100% - 100px);
    padding-left: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #151625;
    overflow: hidden;
  }
  .btn {
    width: 80px;
    height: 35px;
    background: #0054f7;
    border-radius: 0px 17px 17px 0px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 35px;
    cursor: pointer;
  }
}
</style>
